import classNames from 'classnames'
import { Override } from 'maeng-type/Common'
import { ComponentProps, ReactNode, forwardRef, useMemo } from 'react'

export type CardProps = Override<
  ComponentProps<'div'>,
  {
    title?: ReactNode
    content?: ReactNode
    actions?: ReactNode
    image?: string | ReactNode
    compact?: boolean
    imageFull?: boolean
    glass?: boolean
    direction?: 'vertical' | 'horizontal'
    responsive?: boolean
    reverse?: boolean
  }
>

export const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      image,
      title,
      content,
      actions,
      compact = false,
      imageFull = false,
      glass = false,
      direction = 'vertical',
      responsive = false,
      reverse = false,
      className: classProps = '',
      ...props
    },
    ref,
  ) => {
    const className = useMemo(() => {
      return classNames({
        card: true,
        'shadow-xl': true,
        'card-compact': !!compact,
        'image-full': !!imageFull,
        glass: !!glass,
        'card-side': direction === 'horizontal',
        'lg:card-side': !!responsive,
        [classProps]: true,
      })
    }, [compact, imageFull, glass, direction, responsive, classProps])

    const renderImage = () => {
      if (typeof image === 'string') {
        return <img src={image} alt="card-view" />
      }
      return image
    }

    return (
      <div ref={ref} className={className} {...props}>
        {image && !reverse && <figure>{renderImage()}</figure>}
        <div className="card-body">
          {title && <h2 className="card-title">{title}</h2>}
          {content && <p className="card-content">{content}</p>}
          {actions && <div className="card-actions justify-end">{actions}</div>}
        </div>
        {image && !!reverse && <figure>{renderImage()}</figure>}
      </div>
    )
  },
)

export default Card
